"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventrixRebalanced = void 0;
var Card_1 = require("../../Card");
var Tags_1 = require("../../Tags");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRenderItem_1 = require("../../render/CardRenderItem");
var Size_1 = require("../../render/Size");
var InventrixRebalanced = (function (_super) {
    __extends(InventrixRebalanced, _super);
    function InventrixRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.INVENTRIX_REBALANCED,
            tags: [Tags_1.Tags.SCIENCE],
            initialActionText: 'Draw 3 cards',
            startingMegaCredits: 45,
            metadata: {
                cardNumber: 'R43',
                description: 'As first action, draw 3 cards.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(45).nbsp.cards(3);
                    b.corpBox('effect', function (ce) {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('Your temperature, oxygen, ocean, and Venus requirements are +/-3 steps.', function (eb) {
                            eb.plate('Global requirements').startEffect.text('+/- 3');
                        });
                        ce.effect('Cards with a req. cost 1 M€ less.', function (eb) {
                            eb.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.REQ).startEffect.megacredits(-1);
                        });
                    });
                }),
            },
        }) || this;
    }
    InventrixRebalanced.prototype.initialAction = function (player) {
        player.drawCard(3);
        return undefined;
    };
    InventrixRebalanced.prototype.getCardDiscount = function (_player, card) {
        if (card.requirements !== undefined)
            return 1;
        return 0;
    };
    InventrixRebalanced.prototype.getRequirementBonus = function () {
        return 3;
    };
    InventrixRebalanced.prototype.play = function () {
        return undefined;
    };
    return InventrixRebalanced;
}(Card_1.Card));
exports.InventrixRebalanced = InventrixRebalanced;
//# sourceMappingURL=InventrixRebalanced.js.map